import { Spinner } from "./Spinners.styles";

export default Spinner;
